import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import TotalTile from './TotalTile';
import { getChartOptionsWithOverrides } from '../../util/defaultOptions';

HighchartsAccessibility(Highcharts);

interface Props {
  profitGraphArray: number[][];
  finalProfit: string;
}

const ProfitGraph = (props: Props): JSX.Element => {
  const { profitGraphArray, finalProfit } = props;
  const profitYear = useMessage('course4.question3.year');
  const profitToNumber = Number(finalProfit.replace(/\s/g, '').replace(',', '.'));

  const options = getChartOptionsWithOverrides({
    accessibility: {
      enabled: false,
    },
    chart: {
      height: 260,
      width: null,
      type: 'line',
      backgroundColor: 'transparent',
    },
    title: {
      text: undefined,
    },
    plotOptions: {
      series: {
        color: '#EE5A00',
        enableMouseTracking: false,
      },
    },
    yAxis: {
      opposite: true,
      tickAmount: 3,
      min: 0,
    },
    xAxis: {
      showLastLabel: true,
      allowDecimals: false,
      min: 0,
      labels: { format: `{value} ${profitYear}` },
    },
    series: [
      {
        data: profitGraphArray,
        type: 'line',
      },
    ],
    responsive: {},
  });

  return (
    <div className="investoracademy-profitgraph-container">
      <div style={{ display: 'none' }} id="profit-graph-description">
        <Message id="course4.question3.alt_text_graph" />
      </div>
      <div role="img" aria-labelledby="profit-graph-description">
        <div style={{ marginBottom: space.default }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
      <TotalTile sum={profitToNumber} messageId="course4.question3.profit_estimation" />
    </div>
  );
};

export default ProfitGraph;
